<script>
import { Pie, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'
const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.addPlugin(ChartDataLabels)
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/PieChart/index.vue